module.exports = __webpack_public_path__ + "static/logo-b47281913716c8f576aafbedfb0f7526.png";